"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'chat.teaser.cta.label': 'Ask question',
    'chat.teaser.default.prompt1.description': 'What is the atmosphere of mars built with?',
    'chat.teaser.default.prompt1.text': 'What is the atmosphere of mars built with?',
    'chat.teaser.default.prompt2.description': 'How fast can a horse run?',
    'chat.teaser.default.prompt2.text': 'How fast can a horse run?',
    'chat.teaser.default.prompt3.description': 'How to change flat tire?',
    'chat.teaser.default.prompt3.text': 'How to change flat tire?',
};
